<template>
    <ValidationObserver ref="userInfo" v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent="handleSubmit(updateUser)">  
            <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                <template v-slot:header>
                    <p class="mb-0" style="font-size: 21px">Actualización de Terceros</p>
                </template>
                <b-card-text>
                    <b-alert show variant="danger" v-if="errores">
                        <ul >
                            <li v-for="(item, index) in errors" :key="index">{{ item[0] }}</li>
                        </ul>
                    </b-alert>
                    <b-row>        
                        <b-col cols="12" md="6">
                            <ValidationProvider name="Nombre"  rules="required|min:3" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Nombre terceros:"
                                    label-for="nombre">
                                    <b-form-input
                                        id="nombre"
                                        v-model="userInfo.nombre"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el nombre"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="Email"  rules="required|email" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Email Terceros:"
                                    label-for="email">
                                    <b-form-input
                                        id="email"
                                        v-model="userInfo.email"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        readonly
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el correo"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4">
                                <b-form-group
                                    label="Telefono:"
                                    label-for="telefono">
                                    <b-form-input
                                    id="telefono"
                                    v-model="userInfo.telefono"
                                    type="text"
                                    autocomplete="off"
                                    required
                                    placeholder="Ingrese el telefono"
                                    ></b-form-input>
                                </b-form-group>
                        </b-col>
                        <b-col cols="12" md="3" v-if="tipo_tercero_selected == 1 && user.permissions.includes('can_supervise_sales_comission')">
                            <b-form-group
                                label="Comisión de venta:"
                                label-for="comissionOnSale">
                                <b-form-select class="select-size" id="comissionOnSale" v-model="userInfo.commission_percentage_on_sales" :options="commissionOnSalesOptions"></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="3">
                            Estado 
                            <b-form-checkbox v-model="status" name="status" switch v-b-tooltip.hover.left title="Estado Activo/Inactivo del usuario"> 
                            </b-form-checkbox>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="departamento"  rules="required" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Departamento:"
                                    label-for="departamento">
                                    
                                    <b-form-select
                                        v-model="departamento"
                                        :options="departamentos_list"
                                        id="departamento"
                                        class="mb-3"
                                        value-field="id"
                                        text-field="nombre"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        @change="getCiudadesList()"
                                        >
                                        <template #first>
                                            <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="ciudad"  rules="required" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Ciudad:"
                                    label-for="ciudad">
                                   
                                    <b-form-select
                                        v-model="ciudad"
                                        :options="ciudades_list"
                                        id="ciudad"
                                        class="mb-3"
                                        value-field="id"
                                        text-field="nombre"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template #first>
                                            <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="12">
                            <ValidationProvider name="direccion"  rules="required|min:3|max:255" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Dirección:"
                                    label-for="direccion">
                                    <b-form-input
                                        id="direccion"
                                        v-model="direccion"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese la dirección"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                         <b-col cols="12" md="6">
                            <b-form-group label="Tipo de terceros" v-slot="{ ariaDescribedby }">
                            <b-form-radio-group
                                v-model="tipo_tercero_selected"
                                :options="options"
                                :aria-describedby="ariaDescribedby"
                                name="tipo_terceros"
                                stacked
                                size="md"
                            ></b-form-radio-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div v-if="tipo_tercero_selected == 1">
                        <b-row v-for="(item, index) in permissionList" :key="index">
                            <b-col cols="12" md="12">
                                <p class="mb-0" style="font-size: 21px">{{index}}</p>
                            </b-col>
                            <b-col cols="6" md="4" v-for="(item, key) in item" :key="key">
                                    <b-form-checkbox
                                    v-model="permissions[key]"
                                    name="checkbox-1"
                                    :value=key.checked
                                    >
                                    {{item}}
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-if="tipo_tercero_selected == 2">
                        <b-row>        
                            <b-col cols="12" md="6">
                                <ValidationProvider name="tipo_documento"  rules="required" v-slot="{ errors, valid }">
                                    <b-form-group 
                                        label="Tipo Documento:"
                                        label-for="tipo_documento">
                                        
                                        <b-form-select
                                        v-model="userInfo.tipo_documento"
                                        :options="tipo_documento"
                                        id="tipo_documento"
                                        class="mb-3"
                                        value-field="tipo"
                                        text-field="label"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        disabled-field="notEnabled"
                                        ></b-form-select>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="documento"  rules="required|min:3" v-slot="{ errors, valid }">
                                    <b-form-group 
                                        label="Numero de Documento:"
                                        label-for="documento">
                                        <b-form-input
                                            id="documento"
                                            v-model="userInfo.documento"
                                            type="text"
                                            autocomplete="off"
                                            required
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            placeholder="Ingrese el numero de documento"
                                            ></b-form-input>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </div>
                </b-card-text>
                <template v-slot:footer>
                    <b-button variant="danger" class="mr-2" @click.prevent="back">
                        Cancelar
                    </b-button>
                    <b-button variant="success" :disabled="invalid" type="submit">
                        Actualizar
                    </b-button>
                </template>
            </b-card>
        </b-form>
    </ValidationObserver>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
    data(){
        return{
            userInfo: {},
            errors: {},
            errores: false,
            permissionList:{},
            permissions: [],
            status: '',
            tipo_tercero_selected: '',
            options: [
                { text: 'Vendedor', value: '1' },
                { text: 'Cliente Web', value: '2' }
            ],
            tipo_documento: [],
            departamento: '',
            ciudad: '',
            direccion: '',
            departamentos_list: [],
            ciudades_list: [],
        }
    },
    created(){
        this.getInfoUser();
        this.getPermissionsList();
        this.getDepartamentosList();
        
    },
    computed:{
        ...mapState('auth', ['user']),
        commissionOnSalesOptions() {
            return Array.from(Array(100).keys());
        },
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getPermissionsList(){
            this.setLoading(true)
            await this.$conectar.post('/user/get-user-permissions-list')
            .then(response=>{
                this.permissionList = response.data.permissions;
            })
            .catch(response =>{
                console.log(response);
            })
            this.setLoading(false)
        },
        async getInfoUser(){
            this.setLoading(true)
            await this.$conectar.post('/user/find-user',{
                id: this.$route.params.id
            })
            .then(response => {
                this.userInfo = response.data.usuario;
                this.tipo_documento = response.data.tipo_documento;
                if(response.data.usuario.status == 1){
                    this.status = true;
                }else if (response.data.usuario.status == 0){
                    this.status = false;
                }
                this.direccion = this.userInfo.direccion;
                this.departamento = this.userInfo.departamento_id;
                this.ciudad = this.userInfo.ciudad_id;
                this.tipo_tercero_selected = response.data.usuario.tipo_terceros;
                

                this.userInfo.permissions.forEach(key => {
                    this.permissions[key] = true;
                });
            })
            .catch(e =>{
                console.log(e);
            })
            this.setLoading(false)
        },
        back(){
            this.$router.go(-1);
        },
        async updateUser(){
            this.setLoading(true)
            this.permissionArray = [];
            for (var key in this.permissions) {
                if(this.permissions[key]){
                    this.permissionArray.push(key);
                }
            }
            if(this.status === true){
                this.userInfo.status = 1;
            }else{
                this.userInfo.status = 0;
            }

            
            this.userInfo.direccion     = this.direccion;
            this.userInfo.ciudad        = this.ciudad;
            this.userInfo.departamento  = this.departamento;
            this.userInfo.tipo_terceros = this.tipo_tercero_selected;
            this.userInfo.permissions   = this.permissionArray;
            await this.$conectar.post('/user/update-user-info', this.userInfo)
            .then(response=>{
                if(response.data.error == true){
                    this.errores = true;
                    this.errors = response.data.errors;
                }else{
                    this.$root.$bvToast.toast('Se actualizo el usuario correctamente', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this.$router.push({ name: 'listadoUsuarios' });
                }
                })
            .catch(response =>{
                console.log(response);
                this.$bvToast.toast("Parece que hubo un error en el servidor", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },

        async getDepartamentosList() {
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-departamentos-list')
            .then(response =>{
                this.departamentos_list = response.data.departamentosList;
                if(this.departamento){
                    this.getCiudadesList();
                }
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getCiudadesList() {
            this.departamentoSelected = { 
                departamento_id:   this.departamento, 
            }
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-ciudades-list', this.departamentoSelected)
            .then(response =>{
                this.ciudades_list = response.data.ciudadesList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
    }
}
</script>